import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { downloadItemMasterSampleTemplate } from "../helpers/itemMasterSampleTemplate";

const base_assets = process.env.REACT_APP_BASE_ASSETS_URL || "";

/**
 * Excel / CSV picker before Item Master sample download.
 * Open with: data-bs-toggle="modal" data-bs-target={`#${id}`}
 *
 * @param {{ type: string, id?: string }} props
 */
const MasterSampleFormatModal = ({ type = "item", id }) => {
  const { t } = useTranslation();
  const [format, setFormat] = useState("xlsx");
  const [busy, setBusy] = useState(false);
  const modalId = id || `${type}SampleFormatModal`;

  const handleDownload = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await downloadItemMasterSampleTemplate(type, format, t);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="modal fade common-modal"
      id={modalId}
      tabIndex={-1}
      aria-labelledby={`${modalId}Label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <img
              className="common-modal-exclamation-img"
              src={base_assets + "images/icons/exclamation-mark-green.png"}
              alt=""
            />
            <p className="modal-content-text mb-2" id={`${modalId}Label`}>
              {t("Export format")}
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
              <label className="d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name={`${modalId}Format`}
                  value="xlsx"
                  checked={format === "xlsx"}
                  onChange={() => setFormat("xlsx")}
                />
                {t("Excel (.xlsx)")}
              </label>
              <label className="d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name={`${modalId}Format`}
                  value="csv"
                  checked={format === "csv"}
                  onChange={() => setFormat("csv")}
                />
                {t("CSV")}
              </label>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn modal-content-yes"
              data-bs-dismiss="modal"
              disabled={busy}
              onClick={handleDownload}
            >
              {busy ? t("Please wait") : t("Sample")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterSampleFormatModal;
